var _rect, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.0808105,
    width: 32,
    height: 32,
    rx: 10,
    fill: "#FB2C36",
    fillOpacity: 0.05
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.0808 11.6667L20.6677 18.3501C20.5621 20.0576 20.5093 20.9114 20.0813 21.5253C19.8697 21.8287 19.5973 22.0849 19.2813 22.2773C18.6422 22.6667 17.7868 22.6667 16.0759 22.6667C14.3629 22.6667 13.5063 22.6667 12.8668 22.2766C12.5507 22.0838 12.2781 21.8272 12.0666 21.5232C11.6387 20.9084 11.5871 20.0534 11.4839 18.3435L11.0808 11.6667",
    stroke: "#FB2C36",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0808 11.6667H22.0808M18.7846 11.6667L18.3295 10.7278C18.0272 10.1042 17.876 9.79234 17.6153 9.59787C17.5575 9.55473 17.4962 9.51635 17.4321 9.48313C17.1434 9.33333 16.7969 9.33333 16.1038 9.33333C15.3933 9.33333 15.0381 9.33333 14.7446 9.48941C14.6795 9.524 14.6175 9.56393 14.559 9.60877C14.2952 9.81113 14.1479 10.1344 13.8532 10.7808L13.4494 11.6667",
    stroke: "#FB2C36",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4141 19V15",
    stroke: "#FB2C36",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7475 19V15",
    stroke: "#FB2C36",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.73c306369fd3aafa5549a2493c5019a8.svg";
export { ForwardRef as ReactComponent };